import { cn } from '@/lib/utils'

interface RecentSearch {
  id: string
  query: string
}

interface RecentSearchesProps {
  searches: RecentSearch[]
  onSearchClick: (query: string) => void
  onSearchRemove: (id: string) => void
  onClearAll: () => void
  className?: string
}

export function RecentSearches({ 
  searches, 
  onSearchClick, 
  onSearchRemove, 
  onClearAll,
  className 
}: RecentSearchesProps) {
  if (searches.length === 0) {
    return (
      <div className={cn("px-4 py-6", className)}>
        <h2 className="text-[16px] font-semibold text-[#222222] mb-4">최근 검색어</h2>
        <p className="text-[14px] text-[#999999] text-center py-8">
          최근 검색어가 없습니다
        </p>
      </div>
    )
  }

  return (
    <div className={cn("px-4 py-6", className)}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-[16px] font-semibold text-[#222222]">최근 검색어</h2>
        <button
          onClick={onClearAll}
          className="text-[14px] text-[#999999] bg-transparent border-none cursor-pointer hover:text-[#666666] transition-colors"
        >
          전체삭제
        </button>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {searches.map((search) => (
          <div
            key={search.id}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#DEDEDE] rounded-full"
          >
            <button
              onClick={() => onSearchClick(search.query)}
              className="text-[14px] text-[#222222] bg-transparent border-none cursor-pointer"
            >
              {search.query}
            </button>
            <button
              onClick={() => onSearchRemove(search.id)}
              className="p-0 bg-transparent border-none cursor-pointer flex items-center"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path 
                  d="M10 4L4 10M4 4L10 10" 
                  stroke="#666666" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}